import * as React from "react";
import { deepCopy } from "@features/utils/functions";
import IEditable, { TEditable } from "@company/components/Editable/IEditable";
import Edit from "./pencil.svg";

import * as styles from "./EditableStyles.module.scss";
import * as appStyles from "../../AppStyle.module.scss";

export default class Editable extends React.Component<IEditable, TEditable> {
  state: TEditable = {
    editing: false,
  };

  constructor(props: IEditable) {
    super(props);
    this.changeValue = this.changeValue.bind(this);
    this.editStatus = this.editStatus.bind(this);
  }

  changeValue(e: any) {
    const nestedName = this.props.name.split(".");
    let arrayCopy = null;

    if (Array.isArray(this.props._this.state.data)) {
      arrayCopy = deepCopy(this.props._this.state.data);

      arrayCopy.map((elem: any) => {
        if (elem.hasOwnProperty(this.props.name)) {
          elem[this.props.name] = e.target.value;
        }
      });
    }

    if (Array.isArray(arrayCopy)) {
      this.props._this.setState({
        data: arrayCopy,
      });
    } else if (nestedName.length === 2) {
      this.props._this.setState({
        data: {
          ...this.props._this.state.data,
          [nestedName[0]]: {
            ...this.props._this.state.data[nestedName[0]],
            [nestedName[1]]: e.target.value,
          },
        },
      });
    } else {
      this.props._this.setState({
        data: {
          ...this.props._this.state.data,
          [this.props.name]: e.target.value,
        },
      });
    }
  }

  displayUpdatedValue(withDOM: boolean = false) {
    let { data } = this.props._this.state;
    const nestedName = this.props.name.split(".");
    if (Array.isArray(data)) {
      data = data.filter((property: any) => {
        if (property.hasOwnProperty(this.props.name)) {
          return property[this.props.name];
        }
      });
      data = data.length === 0 ? "" : data[0][this.props.name];
    } else if (nestedName.length === 2) {
      data = this.props._this.state.data[nestedName[0]][nestedName[1]]
        ? this.props._this.state.data[nestedName[0]][nestedName[1]]
        : "";
    } else {
      data = !this.props._this.state.data[this.props.name]
        ? ""
        : this.props._this.state.data[this.props.name];
    }
    if (withDOM) {
      return <span>{String(data).length > 0 ? data : this.props.ph}</span>;
    }
    return data;
  }

  editStatus() {
    this.setState({
      editing: !this.state.editing,
    });
  }

  onFocus = () => {
    if (this.props.onFocus) {
      this.props.onFocus(this.props.name);
    }
  };

  render() {
    const className = this.props.cl
      ? [styles.editable, this.props.cl].join(" ")
      : styles.editable;
    const onFocus = this.props.onFocus ? { onFocus: this.onFocus } : null;
    const placeholder = this.props.ph ? this.props.ph : "";

    return (
      <div className={className}>
        {this.state.editing ? (
          <React.Fragment>
            {this.props.type === "input" ? (
              <input
                {...onFocus}
                type="text"
                value={this.displayUpdatedValue(false)}
                onChange={this.changeValue}
                placeholder={placeholder}
                maxLength={255}
              />
            ) : (
              <textarea
                value={this.displayUpdatedValue(false)}
                onChange={this.changeValue}
                rows={10}
                placeholder={placeholder}
              />
            )}
            <button
              onClick={this.editStatus}
              className={appStyles.editButtonActive}
            />
          </React.Fragment>
        ) : (
          <React.Fragment>
            {this.displayUpdatedValue(true)}
            <button onClick={this.editStatus} className={appStyles.editButton}>
              <Edit />
            </button>
          </React.Fragment>
        )}
      </div>
    );
  }
}
